import {REMOVER_FILTRO_CENTRO_CUSTO } from '../types';


export default function removerFiltroCentroCusto (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_CENTRO_CUSTO
  }
}
